export default __webpack_public_path__ + "static/media/resume.bd213c7b.pdf";